export default {
  /**
   * 单位管理
   */

  getUnitType:"/bygApp/findType",
  getProvinceOrCity:"/bygApp/findAllAreas",
  getUnitList:"/bygApp/findAppInfos",
  unitCreateEditDelete:"/bygApp/addOrEditOrDel",
  getUnitDetailWithId:"/bygApp/findAppInfoById",
  getUnitStatisticsWithId:"/bygApp/findAppStatisticsById",
  
  getHallList:"/bygFarewellHall/find",
  getCeremonyList:"/bygAMV2/find",
  getAccountList:"/bygAdmin/findAllAdmins",
  getTemplateAllList:"/bygDeadManLifeTemplate/findAll",
  hallCreateOrEdit:"/bygFarewellHall/addOrEdit",
  deleteHall:"/bygFarewellHall/del",
  templateCreateOrEdit:"/bygDeadManLifeTemplate/addOrEdit",
  deleteTemplate:"/bygDeadManLifeTemplate/del"
}



// WEBPACK FOOTER //
// ./src/api/Unit/urls.js